import { useCategoriaProductoStore, userPromocionesStore } from "@/store/erp";
import { usePaymentMethodsStore } from "@/store/erp/system-settings/payment-methods";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useTypeInstalation } from "@/store/erp/system-settings/type-instalation";
import { useEffect } from "react";
import { Outlet } from "react-router-dom"

const SupervisionVentaCorporativaModule = () => {
  const getPromociones = userPromocionesStore(s => s.getPromociones);
  const getpaymentMethodsFilterPaging = usePaymentMethodsStore(s => s.getpaymentMethodsFilterPaging);
  const getPlansCorporativos = usePlanStore(s => s.getPlansCorporativos);
  const getTypeInstalation = useTypeInstalation(s => s.getTypeInstalation);
  const getCategoriaProducto = useCategoriaProductoStore(s => s.getCategoriaProducto);


  useEffect(() => {
    (async () => {
      const results = await Promise.allSettled([
        getPromociones(),
        getPlansCorporativos({ page_size: 300 }),
        getTypeInstalation({ page_size: 600 }),
        getpaymentMethodsFilterPaging({
          page_size: 600
        }),
        getCategoriaProducto({ page_size: 600 }),
      ]);
      results.forEach((result, index) => {
        if (result.status === 'rejected') {
          console.error(`Data load failed at position ${index}:`, result.reason);
        }
      });
    })();
  }, []);

  return (
    <Outlet />
  );
}
export default SupervisionVentaCorporativaModule
